import ISuitableActivity from './interfaces/ISuitableActivity'

export const Chess: ISuitableActivity = {
  label: 'Chess',
  href: 'https://www.chesskid.com/'
}

export const Coding: ISuitableActivity = {
  label: 'Coding',
  href: 'https://scratch.mit.edu/'
}

export const Music: ISuitableActivity = {
  label: 'Music',
  href: 'https://www.hoffmanacademy.com/'
}

export const Science: ISuitableActivity = {
  label: 'Science',
  href: 'https://www.kidsworldfun.com/learn-science/'
}

export const MartialArts: ISuitableActivity = {
  label: 'Martial Arts',
  href: '#'
}

export const Baking: ISuitableActivity = {
  label: 'Baking',
  href: '#'
}

export const Ballet: ISuitableActivity = {
  label: 'Ballet',
  href: '#'
}

export const Design: ISuitableActivity = {
  label: 'Design',
  href: '#'
}

export const Photography: ISuitableActivity = {
  label: 'Photography',
  href: '#'
}

export const Architecture: ISuitableActivity = {
  label: 'Architecture',
  href: '#'
}

export const Engineering: ISuitableActivity = {
  label: 'Engineering',
  href: '#'
}

export const Dancing: ISuitableActivity = {
  label: 'Dancing',
  href: '#'
}

export const ArtsCrafts: ISuitableActivity = {
  label: 'Arts & Crafts',
  href: '#'
}

export const Sports: ISuitableActivity = {
  label: 'Sports',
  href: '#'
}

export const Acting: ISuitableActivity = {
  label: 'Acting',
  href: '#'
}

export const Directing: ISuitableActivity = {
  label: 'Directing',
  href: '#'
}

export const Therapy: ISuitableActivity = {
  label: 'Therapy',
  href: '#'
}

export const Management: ISuitableActivity = {
  label: 'Management',
  href: '#'
}

export const Writing: ISuitableActivity = {
  label: 'Writing',
  href: '#'
}

export const PublicSpeaking: ISuitableActivity = {
  label: 'Public Speaking',
  href: '#'
}

export const Marketing: ISuitableActivity = {
  label: 'Marketing',
  href: '#'
}

export const Journalism: ISuitableActivity = {
  label: 'Journalism',
  href: '#'
}

export default {
  Chess,
  Coding,
  Music,
  Science,
  MartialArts,
  Baking,
  Design,
  Photography,
  Architecture,
  Engineering,
  Dancing,
  ArtsCrafts,
  Sports,
  Acting,
  Directing,
  Therapy,
  Management,
  Writing,
  PublicSpeaking,
  Marketing,
  Journalism,
  Ballet
}



// WEBPACK FOOTER //
// ./src/data/abitilies/suitableActivities.ts